import { FeatureType } from "../../GameModel";
export function featureTypeFromChanceGameConfigId(gameConfigId) {
    switch (gameConfigId) {
        case "chance-greenfish":
            return FeatureType.GREEN_FISH;
        case "pick-fishfood-1":
            return FeatureType.FISH_FOOD;
        case "chance-redfish":
            return FeatureType.RED_FISH;
        case "pick-fishfood-2":
            return FeatureType.FISH_FOOD;
        case "chance-purplefish":
            return FeatureType.PURPLE_FISH;
        case "chance-goldfish-low":
            return FeatureType.GOLD_FISH;
        case "pick-fishfood-3":
            return FeatureType.FISH_FOOD;
        case "chance-goldfish-high":
            return FeatureType.GOLD_FISH;
        default:
            return FeatureType.NONE;
    }
}
export function featureTypeFromChanceGameConfigIdStrict(gameConfigId) {
    const featureType = featureTypeFromChanceGameConfigId(gameConfigId);
    if (featureType === FeatureType.NONE) {
        throw new Error("Unknown chance game config ID: " + gameConfigId);
    }
    return featureType;
}
//# sourceMappingURL=featureTypeFromChanceGameConfigId.js.map